import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {FlashBanner} from 'shells/flash-banner/flash-banner';

export const MissingFieldsAlert: (...args: any) => any = ({input}: FieldProps) => {
    if (input.value) {
        return (
            <FlashBanner type='warning' onHidden={() => input.onChange('')}>
                {input.value}
            </FlashBanner>
        );
    }

    return null;
};
